import { css, DialogContent as MuiDialogContent, styled } from '@mui/material';

import ModalBodyContent from './ModalBodyContent';
import ModalBodyLoading from './ModalBodyLoading';
import { modalBodyClasses } from './theme';

import type { ModalBodyOwnerState, ModalBodyProps } from './types';

const ModalBody = (props: ModalBodyProps) => {
  const { children, loading = false, ...others } = props;

  const ownerState: ModalBodyOwnerState = {
    ...props,
    loading,
  };

  return (
    <ModalBodyRoot ownerState={ownerState} {...others}>
      <ModalBodyContent>{children}</ModalBodyContent>
      {loading && <ModalBodyLoading />}
    </ModalBodyRoot>
  );
};

ModalBody.displayName = 'ModalBody';

export default ModalBody;

const ModalBodyRoot = styled(MuiDialogContent, {
  target: modalBodyClasses.root,
})<{ ownerState: ModalBodyOwnerState }>(({ ownerState }) => {
  const { loading } = ownerState;

  return css`
    padding: 0;
    overflow-y: unset;

    ${loading &&
    css`
      position: relative;
      min-height: 60px;
    `}
  `;
});
